import { useState } from 'react';
import { Alert, Checkbox, FormControlLabel, TextField, ThemeProvider } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import { useSignupMutation } from '../../redux/Apis/Auth';
import { authErrorMessage } from '../../utils/authSession';
import { StandardInputTheme } from './StandardInputTheme';
import './style.css';
export default function SignupForm() {
  const [form, setForm] = useState({ first_name: '', last_name: '', email: '', phone: '', password: '', confirmation: '' });
  const [accepted, setAccepted] = useState(false);
  const [error, setError] = useState('');
  const [signup, { isLoading }] = useSignupMutation();
  const navigate = useNavigate();
  const submit = async (event) => {
    event.preventDefault();
    if (isLoading) return;
    setError('');
    if (!accepted) return setError('Godkänn villkoren för att skapa ett konto.');
    if (form.password !== form.confirmation) return setError('Lösenorden stämmer inte överens.');
    if (new TextEncoder().encode(form.password).length > 72) return setError('Lösenordet är för långt (högst 72 byte).');
    const payload = { first_name: form.first_name.trim(), last_name: form.last_name.trim(), email: form.email.trim().toLowerCase(), password: form.password };
    if (form.phone.trim()) payload.phone = form.phone.trim();
    try {
      await signup(payload).unwrap();
      navigate('/email-sent', { state: { email: payload.email } });
    } catch (failure) { setError(authErrorMessage(failure, 'Kontot kunde inte skapas. Försök igen.')); }
  };
  const fields = [
    ['first_name', 'Förnamn', 'text', 'given-name'], ['last_name', 'Efternamn', 'text', 'family-name'],
    ['email', 'E-postadress', 'email', 'email'], ['phone', 'Telefon (valfritt)', 'tel', 'tel'],
    ['password', 'Lösenord', 'password', 'new-password'], ['confirmation', 'Bekräfta lösenord', 'password', 'new-password'],
  ];
  return <ThemeProvider theme={StandardInputTheme}><div className="login-form-container shadow">
    <form onSubmit={submit}><h2 className="loginpage_heading">Skapa konto</h2>
      {fields.map(([name, label, type, autoComplete]) => <TextField key={name} fullWidth margin="normal" label={label} type={type} autoComplete={autoComplete}
        required={name !== 'phone'} disabled={isLoading} value={form[name]} onChange={(event) => setForm({ ...form, [name]: event.target.value })}
        inputProps={{ minLength: name.endsWith('_name') ? 2 : type === 'password' ? 6 : undefined, maxLength: type === 'password' ? 72 : name.endsWith('_name') ? 50 : undefined }} />)}
      <FormControlLabel control={<Checkbox checked={accepted} onChange={(event) => setAccepted(event.target.checked)} disabled={isLoading} />}
        label={<span>Jag godkänner <Link to="/terms" target="_blank" rel="noopener noreferrer">villkoren</Link> och <Link to="/privacy" target="_blank" rel="noopener noreferrer">sekretesspolicyn</Link>.</span>} />
      {error && <Alert severity="error" sx={{ my: 2 }}>{error}</Alert>}
      <button type="submit" className="btn btn-login" disabled={isLoading}>{isLoading ? 'Skapar konto…' : 'Skapa konto'}</button>
      <p className="mt-3">Har du redan ett konto? <Link to="/auth/login">Logga in</Link></p>
    </form>
  </div></ThemeProvider>;
}
